var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { ModuleValueUniversal, SchemaModuleUniversal } from './module-universal';
import * as rawJSONSchemaModuleColorectalSurgery from '../../schemas/module-colorectal-surgery.json';
var ModuleValueColorectalSurgery = (function (_super) {
    __extends(ModuleValueColorectalSurgery, _super);
    function ModuleValueColorectalSurgery() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return ModuleValueColorectalSurgery;
}(ModuleValueUniversal));
var SchemaModuleColorectalSurgery = (function (_super) {
    __extends(SchemaModuleColorectalSurgery, _super);
    function SchemaModuleColorectalSurgery() {
        var _this = _super.call(this) || this;
        _this.loadSchema(rawJSONSchemaModuleColorectalSurgery);
        return _this;
    }
    SchemaModuleColorectalSurgery.prototype.hook = function (form) {
        _super.prototype.hook.call(this, form);
        this.listenValue(['discharge_date', 'date_of_surgery'], this.fieldHandlerDischargeDate('length_of_stay').bind(this));
    };
    SchemaModuleColorectalSurgery.prototype.setupValidators = function () {
        _super.prototype.setupValidators.call(this);
        this.validatorDateComparison('date_diagnosis', 'date_of_surgery', '<=');
        this.validatorDateComparison('date_diagnosis', 'discharge_date', '<=');
        this.validatorDateComparison('discharge_date', 'date_of_surgery', '>=');
        this.validatorDateComparison('follow_up', 'date_of_surgery', '>=');
        this.validatorDateComparison('date_of_surgery', 'date_of_birth', '>=');
        this.addValidator('preoperative_cea', function (value, formProperty, form) {
            if (value === null || value === undefined) {
                return [];
            }
            var regex = /^\d+(\.\d)?$/;
            return regex.test(value) ? [] : [{
                    code: 'invalidNumber',
                    path: "#/" + formProperty.path,
                    message: 'Preoperative CEA must be a number with at most one decimal place.'
                }];
        });
    };
    return SchemaModuleColorectalSurgery;
}(SchemaModuleUniversal));
export { SchemaModuleColorectalSurgery };



// WEBPACK FOOTER //
// /var/www/schemas-forms/src/app/forms/module-colorectal-surgery.ts.pre-build-optimizer.js